import React from 'react';

const HideLogo = ({ t }) => {

	return (
		<div style={{
			margin: 20
		}}>
			<h4>{t('setting.msg.hideLogoImage')}</h4>
		</div>
	);
};

export default HideLogo;